module.exports = __webpack_public_path__ + "img/appAsset--customer-econ-ax.4ac4d48b.svg";